var toggle = {
    init: function() {
        $(document.body).on('click', '.js-toggle', function(event) {
            event.preventDefault();
            var target = $($(this).attr('data-target')),
                icon = $(this).find('.js-toggle-icon');
            if (target.hasClass('d-none')) {
                icon.addClass('icon--flip-h');
                target.hide().removeClass('d-none').slideDown('fast');
            } else {
                icon.removeClass('icon--flip-h');
                target.show().slideUp('fast', function() {
                    target.addClass('d-none');
                });
            }
        });
    },
};
toggle.init();
